(ns dashboard.components.panel)

(defn panel [{:keys [class style title actions panel-class]} children]
  [:div.panel.is-clipped {:class class :style style}
   [:div.panel-heading.is-size-6.py-2
    [:div.level
     [:div.level-left>div.is-flex title]
     [:div.level-right actions]]]
   [:div.py-0.px-3
    {:style {:overflow "scroll" :height "100%"}
     :class panel-class}
    children]])
